<template>
  <div>
    <div style="position: absolute;right: 22px;top: 55px;z-index: 9">
      <div @touchstart="showModelList()" @click="showModelList()" class="listIcon pointer">
        <img src="../../assets/images/comprehensive/setting.png" alt="">
      </div>
    </div>
    <!--页面编辑-->
    <div class="modelListDiv" v-if="modelListVisible">
      <el-card class="box-card">
        <div class="clearfix" slot="header">
          <a @touchstart="restore" @click="restore">
            <el-icon class="el-icon-refresh-right text-blue"
                     style="position: absolute;right: 20px;cursor:pointer;"></el-icon>
          </a>
          <span class="text-lightBlue">所有模块</span>
          <div class="text-yellow" style="font-size: 0.8rem">*将模块拖入可以页面删除,将所有模块拖出可直接放入页面</div>
        </div>
        <draggable @choose="chooseEvent" @unchoose="unChooseEvent" animation="300" chosenClass="text-blue" group="model"
                   v-model="modelList">
          <transition-group style="min-height: 40px;display: block">
            <div :key="item.name" v-for="item in modelList">
              <div class="move modelItem">
                {{ item.name === '动力' ? labelName + '设备' : item.name }}
              </div>
            </div>
          </transition-group>
        </draggable>
      </el-card>
    </div>
    <!--左边-->
    <div :class="drag ? 'draggableBorder' : ''" class="draggable draggableLeft">
      <draggable :scroll="true" @choose="chooseEvent" @unchoose="unChooseEvent('left')" animation="300" group="model"
                 style="height: 100%" v-model="leftModelList">
        <transition-group class="draggableGroup">
          <div :key="item.name" v-for="(item,index) in leftModelList">
            <clouded-glass :style="{height: tagSelectedCode==='fire_category_tag' && item.name==='设备告警' ? '605px' : item.height,
            marginBottom: index === leftModelList.length-1 ? '0' : '20px'}"
                           class="move" style="width: 100%;">
              <div :style="{height: item.component === 'Infrastructure' ? '88%' : '100%'}" slot="content">
                <component :extend-data="item.component === 'TemperatureHumidity' ? trendExtendData : null"
                           :is="item.initComponent"
                           :label="item.label"
                           :labelName="item.name === '动力' ? labelName+'设备' : item.name" :space-id="currentSpaceInfo.id"
                           :tag-id="tagSelected === 'all' ? null : tagSelected"
                           meter-height="45%" ups-height="54%"></component>
              </div>
            </clouded-glass>
          </div>
        </transition-group>
      </draggable>
    </div>
    <!--右边-->
    <div :class="drag ? 'draggableBorder' : ''" class="draggable draggableRight">
      <draggable :scroll="true" @choose="chooseEvent" @unchoose="unChooseEvent('right')" animation="300" group="model"
                 style="height: 100%" v-model="rightModelList">
        <transition-group class="draggableGroup">
          <div :key="item.name" v-for="(item,index) in rightModelList">
            <clouded-glass :style="{height: tagSelectedCode==='fire_category_tag' && item.name==='设备告警' ? '605px' : item.height,
            marginBottom: index === rightModelList.length-1 ? '0' : '20px'}"
                           class="move"
                           style="width: 100%;">
              <div :style="{height: item.component === 'Infrastructure' ? '88%' : '100%'}" slot="content">
                <component :extend-data="item.component === 'TemperatureHumidity' ? trendExtendData : null"
                           :is="item.initComponent"
                           :label="item.label"
                           :labelName="item.name === '动力' ? labelName+'设备' : item.name" :space-id="currentSpaceInfo.id"
                           :tag-id="tagSelected === 'all' ? null : tagSelected"
                           meter-height="45%" ups-height="54%"></component>
              </div>
            </clouded-glass>
          </div>
        </transition-group>
      </draggable>
    </div>

    <div class="indoorSetting settingCenter" style="position: absolute;">
      <div style="position:absolute; z-index: 1; top: 78px; left: 12px;cursor: pointer;">
        <img src="../../assets/images/filetImg.png" alt="" title="筛选" @touchstart="screenDialog" @click="screenDialog">
      </div>
      <el-row class="indoorSettingImg">
        <!--内景图 - 只在有效空间时渲染-->
        <indoor-setting 
          v-if="currentSpaceInfo && currentSpaceInfo.id && currentSpaceInfo.id !== '0'"
          :category-tag-id="tagSelected === 'all' ? null : tagSelected" 
          :space-id="currentSpaceInfo.id" 
          :screen-datas="screenDatas"
          :highlight-device-id="highlightDeviceId"
          @showDeviceDetail="showDetail"
          @clearHighlight="$emit('clearHighlight')"/>
        <div v-else class="no-space-tip">
          <p>{{ currentSpaceInfo.title }}</p>
          <p style="margin-top: 10px;">请点击"更换空间"选择要查看的空间</p>
        </div>
      </el-row>
      <ul class="deviceTypeUl">
        <li :key="item.id" class="deviceTypeLi" v-for="item in tagList">
          <input :checked="item.isCheck" :class="item.class" :ref="item.class"
                 @change="changeInput(item.id,item.name)"
                 name="deviceTag"
                 type="radio"/>
          <div>{{ item.name }}态势</div>
        </li>
      </ul>
    </div>
    <!--筛选设备弹窗-->
    <screen-details  @screenDialog="screenDialog" @screenData="screenData" :divVisible="areaBgVisible"
                    :tag-id="tagSelected === 'all' ? null : tagSelected" :space-id="currentSpaceInfo.id"/>
    <!--设备详情-->
    <device-detail :distribution-style="true" ref="deviceDetail"></device-detail>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import {overviewComponents} from "@/assets/js/components/overview";
import IndoorSetting from "@/components/indoor_setting/IndoorSetting";
import draggable from "vuedraggable";
import echarts from "echarts";
import {deleteByPageAndComponentName, getCustomListByPage, savePage} from "@/network/device-custom-page";
import {getSystematicByCodes} from "@/network/systematic";
import {getListByParentCode} from "@/network/extension";
import DeviceDetail from "@/components/device_details/comp/DeviceDetail";
import screenDetails from "@/components/device_details/comp/screenDetails";
import lodash from "lodash";

export default {
  name: "IndoorSettingView",
  components: {
    CloudedGlass,
    overviewComponents,
    IndoorSetting,
    draggable,
    DeviceDetail,
    screenDetails,
  },
  props: ['currentSpaceInfo', 'tagCode', 'highlightDeviceId'],
  mounted() {
    this.trendExtendData = {
      grid: {
        top: '15%',
        right: '18%',
        left: '15%',
        bottom: '10%'
      },
      series: [{
        itemStyle: {
          normal: {
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                offset: 0,
                color: 'rgba(41, 159, 251, 0.1)'
              }, {
                offset: 1,
                color: 'rgba(41, 159, 251,1)'
              }]),
            }
          },
        }
      }, {
        itemStyle: {
          normal: {
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                offset: 0,
                color: 'rgba(0, 0, 0, 0.1)'
              }, {
                offset: 1,
                color: 'rgba(0, 196, 211,1)'
              }]),
            }
          },
        }
      }]
    };
  },
  data() {
    return {
      pageUrl: 'overview',
      // 是否显示“总态势(总)”入口
      showAllSituation: true,
      tagList: [],
      tagSelected: '',
      tagSelectedCode: '',
      trendExtendData: null,
      modelListVisible: false,
      componentList: overviewComponents.map(item => ({...item})), //所有模块
      initComponentList: [], //所有初始化模块
      modelList: [], //模块列表
      leftList: [], //点击时左边页面模块
      rightList: [],//点击时右边页面模块
      leftModelList: [], //当前左边页面模块
      rightModelList: [],//当前右边页面模块
      labelName: "动力",
      drag: false,
      deviceCustomLayouts: [],
      areaBgVisible: false,
      screenDatas:[],
    };
  },
  watch: {
    currentSpaceInfo: {
      handler(data) {
        console.log(data, 'data')
        const tagData =  this.$cookies.get("tagData");
        if (tagData !== null && tagData !== undefined && tagData.tagId && tagData.tagName) {
          console.log('IndoorSettingView - 接收到tagData，准备切换标签')
          // 先清除缓存，避免重复触发
          this.$cookies.remove("tagData");
          // 等待 tagList 加载完成后再选中
          setTimeout(() => {
            this.changeInput(tagData.tagId, tagData.tagName)
          }, 1000)
        }
      },
      deep: true,
      
    },
  },
  created() {
    this.formatAllComponents()
  },
  methods: {
    //获取页面布局
    getCustomListByPage() {
      getCustomListByPage(this.pageUrl).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.deviceCustomLayouts = res.data[0].deviceCustomLayouts
            this.formatCustomComponents()
          } else {
            this.saveCustomPage();
          }
        }
      })
    },
    //格式化所有组件
    formatAllComponents() {
      getSystematicByCodes("capacity_system").then(res => {
        if (res.code === 0) {
          this.initComponentList = [];
          if (res.data.length < 1 || res.data[0].val1 === 'false') {
            this.componentList = this.componentList.filter(item => item.component !== 'comprehensive_situation/EnergyEfficiency')
          } else {
            this.componentList = lodash.cloneDeep(overviewComponents)
          }
          this.componentList.forEach(item => {
            let component = item;
            component.initComponent = () => import('@/components/component/' + item.component + '.vue');
            this.initComponentList.push(lodash.cloneDeep(component))
          })
          this.getTags();
        }
      })
    },
    //获取当前页面模块和模块列表
    formatCustomComponents() {
      const leftModelList = []
      const rightModelList = []
      const name = [];
      
      // 总态势模式：显示所有模块（使用第一个标签的配置作为布局参考）
      const isAllMode = this.tagSelectedCode === 'all_category_tag';
      
      this.deviceCustomLayouts.forEach(item => {
          this.initComponentList.forEach(initComponent => {
            if (item.component === initComponent.component) {
              // 总态势模式下，如果组件配置了 hideInAll，则不显示该组件
              if (isAllMode && initComponent.hideInAll) {
                return
              }

              let params = JSON.parse(item.params)
              name.push(item.component);
              initComponent.params = params
              
              let param;
              if (isAllMode) {
                // 总态势模式：使用第一个可用的配置（优先使用显示的配置）
                param = params.filter(p => p.display);
                if (param.length === 0) {
                  param = params.slice(0, 1); // 如果没有显示的，取第一个
                }
                // 总态势模式强制显示
                if (param.length > 0) {
                  if (param[0].direction === 'left') {
                    leftModelList.push(initComponent)
                  } else {
                    rightModelList.push(initComponent)
                  }
                }
              } else {
                param = params.filter(p => p.tag === this.tagSelectedCode)
                if (param.length > 0) {
                  if (param[0].direction === 'left' && param[0].display) {
                    leftModelList.push(initComponent)
                  } else if (param[0].direction === 'right' && param[0].display) {
                    rightModelList.push(initComponent)
                  } else if (!param[0].display) {
                    name.forEach((i, index) => {
                      if (i === item.component) {
                        name.splice(index, 1)
                      }
                    })
                  }
                }
              }
            }
          })
        }
      )
      this.leftModelList = this.sortDeviceCustomLayouts(leftModelList)
      this.rightModelList = this.sortDeviceCustomLayouts(rightModelList)
      this.modelList = this.initComponentList.filter(item => {
        return name.indexOf(item.component) < 0;
      });
    },
    // 获取设备标签
    getTags() {
      getListByParentCode("device_category_tag").then(res => {
        if (res.code === 0) {
          const tags = [];
          res.data = res.data.filter(item => item.isDisplay)
          
          // 在前面添加"总态势"选项，用于显示所有设备（可通过 showAllSituation 控制是否显示）
          if (this.showAllSituation) {
            const allTag = {
              id: 'all',
              name: '总',
              code: 'all_category_tag',
              isDisplay: true,
              isCheck: false,
              class: 'all'
            };
            res.data.unshift(allTag);
          }
          
          res.data.forEach((item, index) => {
            item.isCheck = false;
            item.class = item.code.split("_")[0];
            if (this.tagCode) {
              if (this.tagCode === item.code) {
                this.tagSelected = item.id;
                this.tagSelectedCode = item.code;
                this.labelName = item.name
                item.isCheck = true;
                item.class = item.class + "-selected";
                this.getCustomListByPage();
              }
            } else {
              if (index === 0) {
                this.tagSelected = item.id;
                this.tagSelectedCode = item.code;
                this.labelName = item.name
                item.isCheck = true;
                item.class = item.class + "-selected";
                this.getCustomListByPage();
              }
            }
            tags.push(item);
          })

          // 若传入了 tagCode 但未匹配到任何标签，则默认选中第一个可用标签，避免页面不加载
          if (!this.tagSelectedCode && tags.length > 0) {
            const first = tags[0]
            this.tagSelected = first.id
            this.tagSelectedCode = first.code
            this.labelName = first.name
            first.isCheck = true
            if (first.class.indexOf("-selected") < 0) {
              first.class = first.class + "-selected"
            }
            this.getCustomListByPage();
          }

          this.tagList = tags;
        }
      })
    },
    //更换选中图标
    changeInput(id,name) {
      this.closeDetail();
      this.$emit('childByValue', name)
      this.tagList.map(item => {
        // 使用 == 进行比较，避免字符串和数字类型不匹配的问题
        if (item.id == id) {
          console.log('选中标签:', item.name)
          this.tagSelected = item.id
          this.tagSelectedCode = item.code
          this.labelName = item.name
          if (item.class.indexOf("-selected") < 0) {
            item.class = this.$refs[item.class][0].className + '-selected'
          }
          item.isCheck = true
          this.formatCustomComponents();
        } else {
          if (item.class.indexOf("-selected") > -1) {
            const index = item.class.lastIndexOf("-");
            item.class = item.class.substring(0, index);
          }
          item.isCheck = false
        }
      })
    },
    showDetail(deviceId) {
      this.$refs.deviceDetail.showDeviceDetails(deviceId);
    },
    closeDetail() {
      this.$refs.deviceDetail.close(false);
    },
    //展示所有模块
    showModelList() {
      this.modelListVisible = !this.modelListVisible
    },
    //鼠标点击选中要拖拽元素时的事件
    chooseEvent() {
      this.drag = !this.drag
      this.leftList = this.leftModelList
      this.rightList = this.rightModelList
    },
    //选中后松开鼠标的事件
    unChooseEvent(direction) {
      this.drag = !this.drag
      let diffArray = []
      let display;
      if (this.leftList.length + this.rightList.length === this.leftModelList.length + this.rightModelList.length) {
        //左右移动模块
        if (this.leftList.length > this.leftModelList.length) {
          //左往右移动
          diffArray = this.setPositionDirection(this.rightModelList, this.rightList, 'right')
        } else if (this.leftList.length === this.leftModelList.length) {
          //上下移动
          if (direction === 'left') {
            diffArray = this.leftModelList
          } else if (direction === 'right') {
            diffArray = this.rightModelList
          }
        } else {
          //右往左移动
          diffArray = this.setPositionDirection(this.leftModelList, this.leftList, 'left')
        }
      } else {
        //添加或删除模块
        if (this.leftList.length > this.leftModelList.length) {
          //左边删除
          display = false
          diffArray = this.getDiffLayout(this.leftList, this.leftModelList)
        } else if (this.leftList.length < this.leftModelList.length) {
          //左边添加
          display = true
          diffArray = this.setPositionDirection(this.leftModelList, this.leftList, 'left')
        } else {
          if (this.rightList.length > this.rightModelList.length) {
            //右边删除
            display = false
            diffArray = this.getDiffLayout(this.rightList, this.rightModelList)
          } else if (this.rightList.length < this.rightModelList.length) {
            //右边添加
            display = true
            diffArray = this.setPositionDirection(this.rightModelList, this.rightList, 'right')
          }
        }
      }
      this.saveCustomPage(diffArray, display)
    },
    // 获取差集布局 arr1>arr2
    getDiffLayout(arr1, arr2) {
      return arr1.filter(item => arr2.indexOf(item) === -1)
    },
    //设置差集布局位置
    setPositionDirection(arr1, arr2, direction) {
      arr1.map(item => {
        if (arr2.indexOf(item) === -1) {
          item.position.map(position => {
            if (position.tag === this.tagSelectedCode) {
              position.direction = direction
            }
          })
        }
      })
      return arr1
    },
    // 布局修改排序
    setPositionSort(modelList, display) {
      modelList.map((model, index) => {
        model.position = model.position.map(item => {
          if (item.tag === this.tagSelectedCode) {
            item.sort = index + 1;
            if (display !== undefined) {
              item.display = display
            }
          }
          return item
        })
        return model
      })
      return modelList
    },
    //布局排序显示
    sortDeviceCustomLayouts(modelList) {
      const isAllMode = this.tagSelectedCode === 'all_category_tag';
      modelList = modelList.sort((a, b) => {
        let aPosition, bPosition;
        if (isAllMode) {
          // 总态势模式：使用第一个可用的配置排序
          aPosition = a.params.find(p => p.display) || a.params[0];
          bPosition = b.params.find(p => p.display) || b.params[0];
        } else {
          aPosition = a.params.filter(param => param.tag === this.tagSelectedCode)[0]
          bPosition = b.params.filter(param => param.tag === this.tagSelectedCode)[0]
        }
        return (aPosition?.sort || 0) - (bPosition?.sort || 0)
      })
      return modelList
    },
    //保存页面布局
    saveCustomPage(modelList, display) {
      if (!modelList) {
        modelList = lodash.cloneDeep(this.componentList);
      } else {
        modelList = this.setPositionSort(modelList, display)
      }
      const deviceCustomPageDto = {};
      const deviceCustomLayouts = []
      modelList.forEach(item => {
        item.params = JSON.stringify(item.position)
        deviceCustomLayouts.push(item);
      })
      if (deviceCustomLayouts.length > 0) {
        const deviceCustomPage = {};
        deviceCustomPage.page = this.pageUrl;
        deviceCustomPageDto.deviceCustomLayouts = deviceCustomLayouts;
        deviceCustomPageDto.deviceCustomPage = deviceCustomPage;
        savePage(deviceCustomPageDto).then(() => {
          this.getCustomListByPage();
        })
      }
    },
    //恢复默认
    restore() {
      this.$confirm('是否恢复默认设置', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            //删除所有布局
            deleteByPageAndComponentName(this.pageUrl).then(res => {
              if (res.code === 0) {
                this.modelListVisible = false;
                this.formatAllComponents();
              }
            })
          }
        }
      });
    },screenDialog(){
      this.areaBgVisible = !this.areaBgVisible;
    },screenData(data){
      this.screenDatas=[];
      this.screenDatas=data;
    }
  }
}
</script>

<style scoped>

.overview .el-card {
  margin: 0;
}

.overview .el-card >>> .el-card__header {
  border-bottom-color: #299ffb5c;
}

.tagPic {
  background-image: url('../../assets/images/index/room-line.png');
  height: 32px;
  background-position: 0 46%;
  background-repeat: no-repeat;
}

.deviceTypeUl {
  margin-top: 40px;
  padding-left: 10px;
  text-align: center;
  /*margin-bottom: 0;*/
}

.deviceTypeLi {
  list-style: none;
  margin-right: 30px;
  display: inline-block;
}

input[type="radio"] {
  -webkit-appearance: none;
  border: none;
  width: 67px;
  height: 68px;
}

.power {
  background: url("../../assets/images/comprehensive/动力设备.png") left center no-repeat;
}

.power-selected {
  background: url("../../assets/images/comprehensive/动力设备选中.png") left center no-repeat;
}

.environment {
  background: url("../../assets/images/comprehensive/环境设备.png") left center no-repeat;
}

.environment-selected {
  background: url("../../assets/images/comprehensive/环境设备选中.png") left center no-repeat;
}

.fire {
  background: url("../../assets/images/comprehensive/消防设备.png") left center no-repeat;
}

.fire-selected {
  background: url("../../assets/images/comprehensive/消防设备选中.png") left center no-repeat;
}

.security {
  background: url("../../assets/images/comprehensive/安防设备.png") left center no-repeat;
}

.security-selected {
  background: url("../../assets/images/comprehensive/安防设备选中.png") left center no-repeat;
}

.network {
  background: url("../../assets/images/comprehensive/网络设备.png") left center no-repeat;
}

.network-selected {
  background: url("../../assets/images/comprehensive/网络设备选中.png") left center no-repeat;
}
.elevator {
  background: url("../../assets/images/comprehensive/梯控.png") left center no-repeat;
}

.elevator-selected {
  background: url("../../assets/images/comprehensive/梯控选中.png") left center no-repeat;
}
.water {
  background: url("../../assets/images/comprehensive/给排水.png") left center no-repeat;
}

.water-selected {
  background: url("../../assets/images/comprehensive/给排水选中.png") left center no-repeat;
}

.synthesize{
  background: url("../../assets/images/comprehensive/停车.png") left center no-repeat;
}
.synthesize-selected{
  background: url("../../assets/images/comprehensive/停车选中.png") left center no-repeat;
}

.all {
  /* background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 50%, #1e3a5f 100%); */
  border: 2px solid #299ffb;
  border-radius: 50%;
  position: relative;
}
.all::after {
  content: '总';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #299ffb;
  font-size: 24px;
  font-weight: bold;
}

.all-selected {
  background: #224F7F;
  border: 2px solid #07E6F8;
  border-radius: 20px;
  position: relative;
}
.all-selected::after {
  content: '总';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #07E6F8;
  font-size: 24px;
  font-weight: bold;
}
.indoorSetting {
  width: calc(60vw - 43px);
  margin: 0 20px;
  display: inline-block
}

.indoorSettingImg {
  width: 100%;
  /*min-height: 700px;*/
  min-height: 67vh;
  height: 70vh;
  text-align: center;
  overflow: hidden;
  line-height: 700px;
}

.listIcon {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: rgba(41, 155, 255, .2);
  text-align: center;
  line-height: 32px;
}

.draggable {
  width: 20vw;
  height: 90vh;
  overflow-y: auto;
}

.draggableLeft {
  float: left;
}

.draggableBorder {
  border: 1px solid #07E6F8;
}

.draggableRight {
  float: right;
}

.draggableGroup {
  height: 100%;
  display: block;
}

.modelListDiv {
  width: 200px;
  margin: 20px;
  right: 0;
  top: 70px;
  position: absolute;
  background-color: rgba(36, 75, 100, .9);
  z-index: 10;
}

.move {
  cursor: move;
}

.pageModelItem {
  margin-bottom: 20px;
}

@media (max-width: 1420px) {
  .draggable {
    width: 25vw;
  }

  .indoorSetting {
    width: calc(50vw - 43px);
  }
}

@media (max-width: 1020px) {
  .draggable {
    width: 48%;
  }

  .indoorSetting {
    width: 48%;
    margin: 20px 0;
  }

  .indoorSetting {
    width: 100%;
  }

  .indoorSettingImg {
    height: auto;

  }
}

@media (max-width: 500px) {
  .draggable {
    width: 100%;
    min-height: 20vh;
    height: auto;
  }

  .indoorSetting {
    width: 100%;
    margin: 20px 0;
    height: auto;
  }

  .indoorSettingImg {
    height: auto;
    min-height: 20vh;
    overflow: hidden;
  }
}

/* 无空间提示样式 */
.no-space-tip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  color: rgba(7, 230, 248, 1);
  font-size: 16px;
  text-align: center;
}

.no-space-tip p {
  margin: 0;
}

</style>
